import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text"]

  // TODO: use mousedown, mousemove, mouseup events to only copy on a true click,
  //       and to ignore click-drag text selection

  async copy() {
    if (this.copying) return

    this.copying = true
    const textTarget = this.textTargets[0]
    const html = textTarget.innerHTML

    await navigator.clipboard
      .writeText(textTarget.innerText)
      .catch(() => this.copyFallback())
      .then(() => {
        setTimeout(() => {
          textTarget.innerHTML = html
          this.copying = false
        }, 2000)
        textTarget.innerHTML = "Copied!"
      })
  }

  // This is a fallback for browsers that do not support navigator.clipboard
  copyFallback() {
    const el = document.createElement("textarea")
    el.value = this.textValue
    document.body.appendChild(el)
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)
  }
}
